import React, { useEffect } from 'react'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData } from 'Pages/ReportsAlerts/Reports/@signals'
import { object, string } from 'yup'
import { AppAsyncOfficesAutocomplete, AppFormGrid, AppMoreOptions } from '@components'
import { Box } from '@mui/material'
import { useComputed, useSignal } from '@preact/signals-react'
import { isEmpty } from '@ui-seeker/utils'

export default function OfficeDropoffField() {
	const showDropoff = useSignal(!!reportFormData.peek()?.idOfficeDropoff)

	return <AppMoreOptions open={showDropoff.value} onToggle={() => showDropoff.value = !showDropoff.value}>
		<AppFormGrid>
			<Box sx={{ gridColumn: 'span 6' }}>
				<OfficeField/>
			</Box>
		</AppFormGrid>
	</AppMoreOptions>
}


function OfficeField() {

	const disableField = useComputed(() => reportFormData.value.idOfficePickup?.length > 1 || reportFormData.value.idOfficeGroup?.length >= 1)

	useEffect(() => {
		if (disableField.value && !isEmpty(reportFormData.value)) setIdOfficeDropoffInfo(null)
	}, [disableField.value])

	const {
		idOfficeDropoff,
		setIdOfficeDropoffInfo,
		error,
	} = useReportFormInfo(reportFormData.peek().idOfficeDropoff, 'idOfficeDropoff', object({ idOfficeDropoff: string().nullable() }))

	return <AppAsyncOfficesAutocomplete
		label="Dropoff Office"
		disabled={disableField.value}
		placeholder="Select a Dropoff Office"
		value={idOfficeDropoff || []}
		error={error}
		onChange={e => setIdOfficeDropoffInfo(e.target.value)}
	/>


}